import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import {
  AUTOMATION_BUILDER_READINESS_KEY,
  AUTOMATION_TEST_FIXTURES_KEY,
} from '@/utils/queryKeys.ts';
import { get_automation_test_fixture_retire_url } from '@/utils/urls.ts';

const useRetireAutomationTestFixture = (versionId: string) => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const automationId = useAutomationId();

  return useMutation({
    mutationFn: async ({ fixtureId }: { fixtureId: string }) => (
      await apiClient.post(get_automation_test_fixture_retire_url(automationId, fixtureId))
    ).data,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: AUTOMATION_TEST_FIXTURES_KEY(automationId) }),
        queryClient.invalidateQueries({
          queryKey: AUTOMATION_BUILDER_READINESS_KEY(automationId, versionId),
        }),
      ]);
    },
  });
};

export default useRetireAutomationTestFixture;
